import {createSlice} from '@reduxjs/toolkit';
import {FormBlogInit} from "./model";
const R = require('ramda');

const initialState = {
    blogForm: FormBlogInit,
};

const blogSlice = createSlice({
    name: 'blog',
    initialState,
    reducers: {
        onBlogFormChange: (state, action) => {
            const {name, value} = action.payload;
            state.blogForm[name] = value;
        },
        initBlogForm: (state, action) => {
            state.blogForm = FormBlogInit;
        },
        setCurrentBlog: (state, action) => {
            state.blogForm = action.payload
        }
    },
});

export const {actions} = blogSlice;
export const {
    onBlogFormChange,
    initBlogForm,
    setCurrentBlog
} = actions;

// reducers

// selectors

export const selBlogForm = (state) => state.blog.blogForm;

const blogReducer = {
    blog: blogSlice.reducer,
};
export default blogReducer;
